import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getManproNotifications,
  markNotificationAsRead,
  markAllNotificationsAsRead,
  deleteNotification,
  bulkDeleteNotifications,
} from '../api/manproNotification';
import toast from 'react-hot-toast';

export const useManproNotifications = (limit = 20, offset = 1) => {
  const queryClient = useQueryClient();
  const queryKey = ['manpro-notifications', limit, offset];

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey,
    queryFn: () => getManproNotifications(limit, offset),
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
  });

  const markAsReadMutation = useMutation({
    mutationFn: (id: string) => markNotificationAsRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['manpro-notifications'] });
    },
    onError: () => {
      toast.error('Gagal menandai notifikasi dibaca');
    },
  });

  const markAllAsReadMutation = useMutation({
    mutationFn: () => markAllNotificationsAsRead(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['manpro-notifications'] });
      toast.success('Semua notifikasi ditandai sudah dibaca');
    },
    onError: () => {
      toast.error('Gagal menandai semua notifikasi');
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id: string) => deleteNotification(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['manpro-notifications'] });
      toast.success('Notifikasi berhasil dihapus');
    },
    onError: () => {
      toast.error('Gagal menghapus notifikasi');
    },
  });

  const bulkDeleteMutation = useMutation({
    mutationFn: (ids: string[]) => bulkDeleteNotifications(ids),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['manpro-notifications'] });
      toast.success('Notifikasi yang dipilih berhasil dihapus');
    },
    onError: () => {
      toast.error('Gagal menghapus notifikasi yang dipilih');
    },
  });

  return {
    notifications: data?.content.notifications.data || [],
    unreadCount: data?.content.unread_count || 0,
    pagination: data?.content.notifications,
    isLoading,
    isError,
    refetch,
    markAsRead: markAsReadMutation.mutate,
    isMarkingAsRead: markAsReadMutation.isPending,
    markAllAsRead: markAllAsReadMutation.mutate,
    isMarkingAllAsRead: markAllAsReadMutation.isPending,
    deleteNotification: deleteMutation.mutate,
    isDeleting: deleteMutation.isPending,
    bulkDeleteNotifications: bulkDeleteMutation.mutate,
    isBulkDeleting: bulkDeleteMutation.isPending,
  };
};
